<template>
  <div class="phone-register-wrapper">
    <div v-if="stepShow" class="stepOneRegister">
      <div class="account-form">
        <div class="form-row phone-input">
            <p class="international-area-code">+86</p>
            <input class="form-input phone-number" type="text" name="userName" v-model="phoneNumber" :placeholder="$t('register.phone')">
            <p class="text-error">{{ $t(phoneError) }}</p>
        </div>

        <div class="form-row">
            <input class="form-input code-input" type="text" name="code" v-model="code" :placeholder="$t('register.code')">
            <button type="button" @click="sendCode" v-bind:class="{ 'send-btn': sendBtn, 'disabled': disabled }" v-bind:disabled="disabled">{{timeText}}{{ $t(valueText) }}</button>
            <p class="text-error">{{ $t(codeError) }}</p>
        </div>

        <div class="form-row">
            <input class="form-input" type="password" name="password" v-model="password" :placeholder="$t('register.password_set')" @keyup.enter="savePwd">
            <p class="text-error">{{ $t(passwordError) }}</p>
        </div>
        <div class="form-row">
          <country-com :lang="lang" v-model:countryInfo="countryInfo"/>
        </div>
        <div class="checkbox-wapper">
          <span v-on:click="alocked" class="checkbox"><i class="icon-box iconfont" v-if="!checked"></i><i class="iconfont icon-checked" v-else></i></span>
          <span style="color: #cccccc">{{ $t('register.protocol_a') }}<span class="checkbox-text" @click="registerService" style="color: #272f44">{{ $t('register.protocol_b') }}</span></span>
        </div>
        <div class="form-row">
          <button @click="savePwd" v-bind:class="{ 'save-phone-btn': checked, 'no-save-phone-btn': !checked }" v-bind:disabled="!checked">{{ $t('register.submit') }}</button>
        </div>
        <div class="form-row login">
          <p><span @click="gotoLogin" class="login-btn">{{ $t('register.login_now') }} <span class="iconfont icon-login-right"></span></span></p>
        </div>
      </div>
    </div>
    <div v-if="stepShowTwo" id="success">
      <div class="success-wapper">
        <img class="success-img" src="../../assets/success.png" alt="success">
        <p>{{ $t('register.success') }}</p>
        <div class="changeBtn">
          <button class="login_btn" @click="saveStepThree">{{ $t('register.login_re') }}</button>
        </div>
      </div>
    </div>
    <loading :appear="processing"></loading>
  </div>
</template>

<script>
import Config from 'common/script/config.js'
import Validate from 'common/script/validate.js'
import loading from 'components/loading/loading'
import MD5 from 'common/script/md5.js'
import CountryCom from 'components/country/countryCom.vue'

export default {
  props: ['lang'],
	data () {
    return {
      phoneNumber: '',
      password: '',
      code: '',
      stepShow: true,
      stepShowTwo: false,
      sendBtn: true,
      disabled: false,
      phoneError: '',
      codeError: '',
      passwordError: '',
      time: 60,
      timeText: '',
      email: '',
      valueText: 'register.get_code',
      timerFire: '',
      checked: true,
      processing: false,
      countryInfo: {}
    }
  },
  created () {
	  this.$initCaptcha()
    window.addEventListener('online', this.sendCode)
  },
  components: {
    loading,
    CountryCom
	},
  methods: {
    saveStepThree: function () {
      window.location.href = 'index.html'
    },
    registerService: function () {
      window.open('protocol.html')
    },
    gotoLogin: function () {
      window.location.href = 'index.html'
    },
    formCheck: function () {
      this.reset()
      var validate = true
      if (Validate.stringEmpty(this.phoneNumber)) {
        this.phoneError = 'register.phone'
        validate = false
      }
      if (!Validate.isTel(this.phoneNumber)) {
        this.phoneError = 'register.error_phone'
        validate = false
      }
      if (Validate.stringEmpty(this.code)) {
        this.codeError = 'register.error_code_1'
        validate = false
      }
      if (Validate.stringEmpty(this.password)) {
        this.passwordError = 'register.password_error_1'
        validate = false
      }
      if (!Validate.passwordRule(this.password)) {
        this.passwordError = 'register.password_set'
        validate = false
      }

      return validate
    },
    reset: function () {
      this.phoneError = '' // 清空错误信息
      this.passwordError = '' // 清空错误信息
      this.codeError = '' // 清空错误信息
    },
    sendCode: function () {
      if (Validate.stringEmpty(this.phoneNumber)) {
        this.phoneError = 'register.phone'
        return
      }
      if (!Validate.isTel(this.phoneNumber)) {
        this.phoneError = 'register.error_phone'
        return
      }
      if (navigator.onLine) {
        this.processing = false
        let lang = Config.cookieGet(Config.COOKIE_KEY.LANG)
        if (lang === 'zh-CN') {
          lang = 'zh-cn'
        } else if (lang === 'zh-TW') {
          lang = 'zh-tw'
        } else {
          lang = 'en'
        }
        this.$showCaptcha(300, lang, (res) => {
          let url = Config.passportHost + '/public/code/mobile/behavior/' + this.phoneNumber + '?ticket=' + res.ticket + '&rand=' + res.rand
          this.$http.get(url).then((response) => {
            response = response.body
            this.reset()
            if (response.code === 1000) {
              this.sendBtn = false
              this.disabled = true
              var itemThis = this
              itemThis.timeText = itemThis.time
              itemThis.valueText = 'register.get_code_tip_re'
              this.timerFire = window.setInterval(function () {
                if (itemThis.time <= 0) {
                  itemThis.time = 60
                  itemThis.timeText = ''
                  itemThis.sendBtn = true
                  itemThis.disabled = false
                  itemThis.valueText = 'register.get_code'
                  window.clearInterval(itemThis.timerFire)
                } else {
                  itemThis.time--
                  itemThis.timeText = itemThis.time
                  itemThis.valueText = 'register.get_code_tip_re'
                }
              }, 1000)
            } else if (response.code === 1009) {
              this.codeError = 'register.error_code_2'
            } else if (response.code === 1010) {
              this.codeError = 'register.error_code_4'
            } else if (response.code === 1023) {
              this.codeError = 'register.error_code_5'
            }
          })
        }, (err) => {
          this.processing = false
          console.log(err)
        })
      } else {
        this.processing = true
      }
    },
    alocked: function () {
      this.checked = !this.checked
    },
    savePwd: function () {
      if (this.formCheck()) {
        this.processing = true
        this.$http.post(Config.passportHost + '/public/register/mobile', {
          'mobile': this.phoneNumber,
          'password': MD5.hex_md5(this.password),
          'code': this.code,
          'countryCode': this.countryInfo.countryCode
        }).then((response) => {
          this.processing = false
          this.reset()
          response = response.body
          if (response.code === 1000) {
            this.login() // 直接登录，
          } else if (response.code === 1006) {
            this.phoneError = 'register.not_support'
          } else if (response.code === 1007) {
            this.phoneError = 'register.error_phone'
          } else if (response.code === 1011) {
            this.phoneError = 'register.already_bound'
          } else if (response.code === 1014) {
            this.codeError = 'register.error_code_3'
          }
        })
      }
    },
    login: function () {
      this.processing = true
      this.$http.post(Config.passportHost + '/login/', {
        'username': this.phoneNumber,
        'password': MD5.hex_md5(this.password)
      }).then((response) => {
        this.processing = false
        response = response.body
        if (response.code === Config.R_CODE.SUCCESS) {
          Config.cookieSet(Config.COOKIE_KEY.U_ID, response.body.id)
          Config.cookieSet(Config.COOKIE_KEY.TOKEN, response.body.token)
          Config.cookieSet(Config.COOKIE_KEY.USER_NAME, response.body.name)
          var callback = Config.getReqParam('service')
          if (!Validate.stringEmpty(callback)) {
            callback = Config.appendParam(callback, 'token', response.body.token)
            callback = Config.appendParam(callback, 'u_id', response.body.id)
            // console.log(callback)
            window.location.href = Config.appendParam(callback, 'lang', Config.lang())
          } else {
            Config.setLocalStore('request_flag', 1)
            window.location.href = Config.DEFAULT_PAGE
          }
        }
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.yp-riddler-mark
  display none!important
.phone-register-wrapper
  .account-form
    padding-top 0rem
    .form-row
    &.phone-input
      margin-top 0rem
      margin-bottom 0rem
      .text-error
        min-height 0.16rem
        line-height 0.16rem
      .international-area-code
        display inline-block
        width 0.3rem
        font-size 0.12rem
        color #adadad
      .phone-number
        display inline-block
        width 2.7rem
      .code-input
        width 2rem
        height 0.3rem
      .send-code-btn, .send-btn
        float right
        min-width 0.97rem
        height 0.3rem
        line-height 0.3rem
        font-size 0.12rem
        cursor pointer
      .disabled
        float right
        //margin-top 0.05rem
        min-width 1rem
        height 0.3rem
        line-height 0.3rem
        font-size 0.12rem
        cursor auto
        background-color #a9acb4
      .login-btn
        cursor pointer
      .no-save-phone-btn
        cursor default
        background-color #a9acb4
    .checkbox-wapper
      margin-top 0.32rem
      margin-bottom 0.08rem
      .checkbox-text, input
        cursor pointer
      .checkbox
        font-size 0.14rem
        cursor pointer
        color #272f44
    .login
      margin-top 0.16rem
      font-size 0.12rem
      .icon-login-right
        font-size 0.08rem
        color #979797

  .active
    .icon-box:before
      content "\e908"
@media screen and (max-device-width: 720px), (max-width: 720px)
  .phone-number
    display inline-block
    width 2.684rem !important
  .account-form
    .form-row
      .code-input
        width 1.95rem !important
        height 0.44rem !important
      .send-btn
        float right
        margin-top 0.05rem !important
        min-width 1rem !important
        height 0.35rem !important
        line-height 0.35rem !important
        font-size 0.12rem !important
</style>



// WEBPACK FOOTER //
// phoneRegister.vue?138a2e60